<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Contatti', route: '/backoffice/contatti' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Elenco contatti</h2>
    </div>

    <p-table #dt [loading]="loading" [value]="contatti" responsiveLayout="stack" [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true"
        [globalFilterFields]="['titolo', 'descrizione']" currentPageReportTemplate="{first} di {last} su {totalRecords} contatti"
        [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full items-stretch">
                <input type="text" pInputText class="flex-1" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca contatti…" />
                <div class="table-toolbar-btns">
                    <a class="acc-btn acc-btn-primary" routerLink="/backoffice/contatti/add">+ Aggiungi contatto</a>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="titolo">Titolo <span class="inline-flex"><p-sortIcon field="titolo" /></span></th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contatto>
            <tr>
                <td><span class="p-column-title">Titolo</span><span class="cell-nome">{{contatto.titolo}}</span></td>
                <td class="text-center">
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/contatti/' + contatto.id" pTooltip="Modifica" tooltipPosition="bottom"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteContatto>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteContatto()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteContatto()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteContatto($event, contatto)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2">Nessun contatto trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
